import React from 'react';


function AraNotFound() {
    return (
        <h1>هذه الصفحة غير موجودة</h1>
    );
}

export default AraNotFound